export const formatDesignElementVersion = (
  major?: number | null,
  minor?: number | null,
): string | undefined => {
  if (
    major === null ||
    major === undefined ||
    minor === null ||
    minor === undefined
  ) {
    return undefined;
  }

  return `${major}.${minor}`;
};
